import { PropsWithChildren } from 'react'
import { Tooltip, Typography, Zoom } from '@mui/material'

export default function CustomToolTip({ 
    placement, 
    offset, 
    message,
    content,
    color,
    backColor, 
    children 
}: any & PropsWithChildren) {
    return (
        <Tooltip 
                arrow={true}
                PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: offset || [0,0],
                        },
                      },
                    ],
                  }}
                componentsProps={{
                    arrow: {
                        sx: {
                            "&::before": {
                              backgroundColor: backColor?backColor:"#000",
                              boxShadow: 1
                            }
                          }
                    },
                    tooltip: {
                        sx: {
                            color: color?color:"#FFF",
                            backgroundColor: backColor?backColor:"#000",
                            fontSize: ".8rem",
                            boxShadow: 1
                        }
                    }
                }} 
                title={ content ? content :
                        <Typography  
                            variant="szBody.Regular.xSmall"
                            color={color?color:"#FFF"}>
                            {message}
                        </Typography> 
                    }
                TransitionComponent={Zoom} 
                placement={placement || 'left'}>
            {children}
        </Tooltip>
    )
}